export type Dictionary<T extends string, R = string> = { [key in T]: R };
export type ToString<T extends string, R = string> = (value: T | undefined) => R | undefined;

export function generateToString<T extends string, R = string>(mapping: Dictionary<T, R>): ToString<T, R> {
    return value => {
        if (value === undefined) {
            return undefined;
        }

        return mapping[value];
    };
}
